package link.erpango.quip.domain.entities
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class DSparePart(
    val id: Long? = null, // Backend ID
    @Transient
    val localId: Long? = null, // Database PK
    val categoryId: String,
    val sparePartId: String,
    val brand: String,
    val model: String,
    val additionalInfo: String,
    val durabilityDays: Int?,
    @kotlinx.serialization.EncodeDefault
    val quantity: Double = 1.0,
    val unit: String? = null,
    val signature: String? = null,
    val reference: String? = null
)

// Entidades para los diccionarios de categorías y repuestos
@Serializable
data class DSparePartCategory(
    val id: String,
    val translationKey: String
)

@Serializable
data class DSparePartType(
    val id: String,
    val categoryId: String,
    val translationKey: String,
    val hasQuantity: Boolean = false,
    val unit: String? = null
)

@Serializable
data class DSparePartCatalog(
    val categories: Map<String, String>, // id -> translationKey
    val sparePartTypes: Map<String, DSparePartType> // id -> SparePartType
)